import "../App.css";
import "@rainbow-me/rainbowkit/styles.css";

import { useNavigate } from "react-router-dom";

import { styled } from "@mui/material/styles";
import Tab, { tabClasses } from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React from "react";
import { amber, brown } from "@mui/material/colors";
import Box from "@mui/material/Box";

const TabItem = styled(Tab)(({ theme }) => ({
  // opacity: 1,
  // "&:hover": {
  //   backgroundColor: "brown[500]",
  // },
  // [theme.breakpoints.up("md")]: {
  //   minWidth: 120,
  // },
  // ["&.${tabClasses.selected}"]: {
  //   color: "#1da1f2",
  // },
}));

export const TabsMenu = () => {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: "100%",
        borderBottom: 1,
        borderColor: brown[900],
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        centered
        TabIndicatorProps={{
          style: { background: "green" },
        }}
        sx={{
          ".MuiTab-textColorPrimary": {
            "&.Mui-disabled": { color: brown[700] },
            "&.Mui-selected": { color: amber[500] },
          },
        }}
      >
        <TabItem
          label="Home"
          onClick={() => {
            navigate("/");
          }}
        />
        <TabItem
          label="Admin"
          onClick={() => {
            navigate("/admin");
          }}
        />
        <TabItem
          label="Officer"
          onClick={() => {
            navigate("/officer");
          }}
        />
        <TabItem
          label="Tribe Member"
          onClick={() => {
            navigate("/tribemember");
          }}
        />
        {/* <TabItem label="Disabled" disabled /> */}
        <TabItem
          label="Recruit"
          onClick={() => {
            navigate("/recruit");
          }}
        />
      </Tabs>
    </Box>
  );
};
